import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentMember: (state) => state.currentMember,
  }),
  ...mapGetters('auth', ['loggedIn']),
};

export const authMethods = mapActions('auth', [
  'logIn',
  'getCode',
  'logOut',
  'storeMember',
]);

export const cartComputed = {
  ...mapState('booking', {
    currentCart: (state) => state.cachedCart,
    currentPrepaidCart: (state) => state.cachedPrepaidCart,
    currentSelect: (state) => state.cachedSelect,
  }),
};

export const merchantComputed = {
  ...mapState('merchant', {
    currentMerchant: (state) => state.cached,
  }),
};

export const setComputed = {
  ...mapState('set', {
    currentLanguage: (state) => state.cachedLanguage,
  }),
};
